export default __webpack_public_path__ + "static/media/choose-3.11e0e6f1.png";